import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';

class InceptionService {
    stickyContainer(element) {
        inception.stickyContainer(this.getNativeElement(element));
    }
    stickyReset() {
        inception.sticky.reset();
    }
    stickyFooterCalculate() {
        inception.stickyFooter.calculate();
    }
    initTabNav() {
        inception.tabnav();
    }
    scrollToElement(element, offset, transitionSpeed, completeCb) {
        inception.scrollToElement(this.getNativeElement(element), offset, transitionSpeed, completeCb);
    }
    init() {
        inception.init();
    }
    equalize(element) {
        element ? inception.equalize(this.getNativeElement(element)) : inception.equalize();
    }
    rsFndtnDropdownInput(element) {
        inception.rsFndtnDropdownInput(this.getNativeElement(element));
    }
    rsFndtnDropdownClose() {
        inception.rsFndtnDropdownClose();
    }
    rsDatepicker(element, config) {
        return config
            ? inception.rsDatepicker(this.getNativeElement(element), config)
            : inception.rsDatepicker(this.getNativeElement(element));
    }
    rsTooltip(element, action) {
        action
            ? inception.rsTooltip(this.getNativeElement(element), action)
            : inception.rsTooltip(this.getNativeElement(element));
    }
    popover(element) {
        inception.popover(this.getNativeElement(element));
    }
    panelExpand(element, enableAngularBindings) {
        inception.panelExpand(this.getNativeElement(element), enableAngularBindings);
    }
    panelDropdown(element) {
        inception.panelDropdown(this.getNativeElement(element));
    }
    panelAccordion(element) {
        inception.panelAccordion(this.getNativeElement(element));
    }
    progressbar(element) {
        inception.progressbar(this.getNativeElement(element));
    }
    tabsSlider(element) {
        inception.tabsSlider(this.getNativeElement(element));
    }
    carousel(element, breakpoints) {
        inception.carousel(this.getNativeElement(element), breakpoints);
    }
    navDropdown() {
        inception.navDropdown.init();
    }
    breakpoints() {
        return inception.breakpoints;
    }
    webComponentLoad(element) {
        inception.webComponentLoad(this.getNativeElement(element));
    }
    cssLoad(element) {
        inception.cssLoad(this.getNativeElement(element));
    }
    lazyLoadReflow(element) {
        inception.lazyLoad.reflow(this.getNativeElement(element));
    }
    forms(element) {
        inception.forms(this.getNativeElement(element));
    }
    focustrap(id) {
        inception.focustrap(id);
    }
    actionbar(element) {
        inception.actionbar(this.getNativeElement(element));
    }
    actionMenu(document) {
        inception.actionMenu(document);
    }
    tabs(element) {
        inception.tabs(this.getNativeElement(element));
    }
    getNativeElement(element) {
        return typeof element === 'string' ? jQuery(element) : element.nativeElement;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: InceptionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: InceptionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: InceptionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { InceptionService };
